import { __decorate } from "tslib";
/**
 *  Created by daiwenjuan on 2020/9/10 14:12.
 */
import { action, observable } from 'mobx';
var PermissionVm = /** @class */ (function () {
    function PermissionVm() {
        this.isEnableMC = false;
        this.isCorpMC = false;
    }
    PermissionVm.prototype.setEnableMC = function (value) {
        this.isCorpMC = (value === null || value === void 0 ? void 0 : value.type) === 'MC';
        if (!this.isCorpMC) {
            this.isEnableMC = true;
            return;
        }
        var permissions = value === null || value === void 0 ? void 0 : value.permissions;
        if (permissions && permissions[0] && permissions[0].auth) {
            this.isEnableMC = true;
        }
        else {
            this.isEnableMC = false;
        }
    };
    PermissionVm.prototype.getEnabledEdit = function (value) {
        if (!this.isCorpMC) {
            return true;
        }
        var nodePermissions = value === null || value === void 0 ? void 0 : value.permissions;
        if (Array.isArray(nodePermissions)) {
            return !!nodePermissions.find(function (el) { return el.name === 'ALL' && el.auth; });
        }
        return false;
    };
    PermissionVm.NAME = Symbol('PayeeAccountPermissionVm');
    __decorate([
        observable
    ], PermissionVm.prototype, "isEnableMC", void 0);
    __decorate([
        observable
    ], PermissionVm.prototype, "isCorpMC", void 0);
    __decorate([
        action
    ], PermissionVm.prototype, "setEnableMC", null);
    return PermissionVm;
}());
export { PermissionVm };
